<template>
  <div  :style="{paddingTop:navbarheight}" id="pic" style="transform: perspective(500px) matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1) ">
    <my-top title="审批详情" lefttext="返回"  @leftclick="goBack" style="padding-bottom:20px" ></my-top>
    <div class="formData">
      <!-- <div class="box"> -->
        <iframe id="iframe" class="ifr"
          style="border:none;display: block;margin: 10px auto;"
            frameborder="no" border="0"
            :width="searchTableWidth"
            :height="searchTableHeight"
          v-bind:src="reportUrl"
        ></iframe>
      </div>
    <!-- </div> -->
		<Overlay :show="OverlayShow" @click="OverlayShow = false" :z-index="999999">
			<div class="loadingWrapper" @click.stop>
				<loading color="#1989fa" type="spinner" />
			</div>
		</Overlay>
  </div>
</template>
<script>
    import AlloyFinger from "@/utils/alloyfinger";
    import "@/utils/transform";
    import To from "@/utils/to";
    import {DevelopmentURL, ImgBaseURL} from '@http/config';
    import {Loading, Overlay} from 'vant';

    export default {
  components: {
    Overlay,Loading 
  },
  data() {
      return {
        DevelopmentURL:DevelopmentURL,
          reportUrl: '',
          searchTableHeight: 0,
          searchTableWidth: 0,
          OverlayShow:true
    }
  },
   mounted() {
    window.onresize = () => {
      this.searchTableHeight = window.innerHeight;
      this.searchTableWidth = window.innerWidth*3
    };
    this.$nextTick(function () {
      this.searchTableHeight = window.innerHeight;
      this.searchTableWidth = window.innerWidth*3
    });
    let that = this;
    let element = document.getElementById("pic");
    function ease(x) {
        return Math.sqrt(1 - Math.pow(x - 1, 2));
    }
    Transform(element);
    new AlloyFinger(element, {
        multipointStart: function () {
            that.dis = element.scaleX;
        },
        multipointEnd: function() {
            To.stopAll();
            if (element.scaleX < 0.5) {
                new To(element, "scaleX", 0.5, 500, ease);
                new To(element, "scaleY", 0.5, 500, ease);
            }
            if (element.scaleX > 5) {
                new To(element, "scaleX", 2, 500, ease);
                new To(element, "scaleY", 2, 500, ease);
            }
        },
        pinch: function (evt) {
            element.scaleX = element.scaleY = that.dis * evt.zoom;
        },
        pressMove: function (evt) {
            element.translateX += evt.deltaX;
            element.translateY += evt.deltaY;
            evt.preventDefault();
        },
    });

  },
  computed: {
    user() {
      return localStorage.getItem("vuex") ? JSON.parse(localStorage.getItem("vuex")).user : {}
    },
    params() {
      return '?access_token=' + this.user.token + 
      '&refresh_token=' + this.user.refresh_token + 
      '&id=' + this.$route.query.id + 
      '&businessId=' + this.$route.query.id + 
      "&clientMode=phone"
    }
  },
  created() {
    setInterval(() =>{
        this.OverlayShow=false
    }, 2000);
    // let url = (this.DevelopmentURL.indexOf('pm.cscecxn.com') > -1) ? (this.DevelopmentURL.substr(0,this.DevelopmentURL.length-6) + '8080') : 'http://admin.zj8j.cdtest.cddpi.com' // 测试环境+生产环境
    // let url =  'http://testpm.cscecxn.com:8080'  //uat环境
    // let url =  'http://mzuul.zj8j.cddev.cddpi.com:8080'  //  开发环境
    // const url = ImgBaseURL
      const url = process.env.VUE_APP_auditUrl + '/appApproval'
      this.reportUrl = url + this.params
      // console.log(this.reportUrl)
  },
  methods:{
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>

.formData{
    width: 100%;
    overflow-x: scroll;
}
.box{
    width:100%;
    overflow: auto;
}
</style>